import React from "react";

import TaskLayout from "./task";
import Attributes from "contexts/attributes/attributes";

const PhotoLayout = ({ children }) => {
    return (
        <TaskLayout>
            <Attributes>
                {children}
            </Attributes>
        </TaskLayout>
    );
};

export default PhotoLayout;
